import { NgModule } from '@angular/core';

import { CoreModule } from '../core/core.module';
import { SharedModule } from '../shared/shared.module';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';

import { AuthGuard } from '../core';
import { NewsletterComponent } from './newsletter/newsletter.component';

@NgModule({
  imports: [CoreModule, SharedModule, HomeRoutingModule],
  declarations: [HomeComponent, NewsletterComponent],
  providers: [AuthGuard]
})
export class HomeModule {}
